import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { GridModule, ExcelModule, PDFModule } from "@progress/kendo-angular-grid";
import { IntlModule } from "@progress/kendo-angular-intl";
import { ButtonModule, ButtonsModule } from "@progress/kendo-angular-buttons";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { MenusModule } from "@progress/kendo-angular-menu";
import { PopupModule } from "@progress/kendo-angular-popup";
import { FilterModule } from "@progress/kendo-angular-filter";
import { LabelModule } from "@progress/kendo-angular-label";
import { SVGIconModule } from '@progress/kendo-angular-icons';

import { RemoteKendoGridComponent } from "./grid.component";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { AfterValueChangedDirective } from "../../directives/after-value-changed.directive";
import { PersistListDialogComponent } from "../common/components/persist-list-dialog.component";
import { PersistModelDialogComponent } from "../common/components/persist-model-dialog.component";
import { MultiCheckFilterComponent } from "../common/components/multicheck-filter";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        GridModule, ExcelModule, PDFModule, ButtonModule, ButtonsModule, MenusModule, PopupModule, LabelModule, SVGIconModule,
        InputsModule, DialogModule, FilterModule, DropDownsModule, IntlModule, AfterValueChangedDirective, MultiCheckFilterComponent,
        PersistModelDialogComponent, PersistListDialogComponent],
    exports: [RemoteKendoGridComponent],
    declarations: [RemoteKendoGridComponent],
})
export class RemoteKendoGridModule { }
